'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"arrive_Button__roadhog","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"arrive_Button__blueridge","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"arrive_Button__frogger","whoaNelly":"#ffedf1","jackknife":"#cb2024","button":"arrive_Button__button","md":"arrive_Button__md","lg":"arrive_Button__lg","buttonPrimary":"arrive_Button__buttonPrimary","buttonSecondary":"arrive_Button__buttonSecondary","buttonText":"arrive_Button__buttonText"};

var _excluded = ["className", "children", "disabled", "onClick", "style", "text", "type", "theme", "size"];
var Button = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _cx;

  var className = _ref.className,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'ethanol' : _ref$theme,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement("button", _extends({
    className: cx__default["default"](styles.button, styles[size], (_cx = {}, _defineProperty(_cx, styles.buttonPrimary, type === 'primary'), _defineProperty(_cx, styles.buttonSecondary, type === 'secondary'), _defineProperty(_cx, styles.buttonText, text), _defineProperty(_cx, styles.roadhog, theme === 'roadhog'), _defineProperty(_cx, styles.blueridge, theme === 'blueridge'), _defineProperty(_cx, styles.frogger, theme === 'frogger'), _cx), className),
    disabled: disabled,
    onClick: onClick,
    style: style,
    ref: ref
  }, rest), children);
});
Button.displayName = 'Button';
Button.propTypes = {
  className: PropTypes__default["default"].string,
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),
  disabled: PropTypes__default["default"].bool,
  onClick: PropTypes__default["default"].func,
  style: PropTypes__default["default"].object,
  type: PropTypes__default["default"].oneOf(['primary', 'secondary']),
  theme: PropTypes__default["default"].oneOf(['ethanol', 'roadhog', 'blueridge', 'frogger']),
  size: PropTypes__default["default"].oneOf(['md', 'lg']),
  text: PropTypes__default["default"].bool
};

module.exports = Button;
